import VarietyDropdown from './VarietyDropdown';

export default VarietyDropdown;
